import * as types from "./types";

const mutations = {
  [types.PROCESSING_DRIVER_BONUS](state, value) {
    state.processing = value;
  },
  [types.PROCESSING_BULK_DRIVER_BONUS](state, value) {
    state.bulkProcessing = value;
  },
  [types.GET_DRIVER_BONUS](state, value) {
    state.bonuses = value;
  },
  [types.CREATE_DRIVER_BONUS](state, value) {
    state.bonuses.push(value);
  },
  [types.DELETE_DRIVER_BONUS](state, value) {
    let idx = state.bonuses.findIndex((el) => el.id === value);
    if (idx !== -1) {
      state.bonuses.splice(idx, 1);
    }
  },
};

export default mutations;
